import { inject, injectable } from "inversify";
import { DirectorModel, ICPLDirectorsClient, NewDirectorModel, UpdateDirectorModel } from "./api/cplapi/CPLAPI";
import { DirectorLinkedClientPortalUserModel, ICPLAuthDirectorsClient } from "./api/cplauthapi/CPLAuthAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IDirectorsService {
  getDirectors(includeDeleted: boolean): Promise<DirectorModel[]>;
  getDirector(directorID: string, includeDeleted: boolean): Promise<DirectorModel>;
  createDirector(newDirectorModel: NewDirectorModel): Promise<string>;
  updateDirector(model: UpdateDirectorModel): Promise<void>;
  deleteDirector(directorID: string): Promise<void>;
  getLinkedClientPortalUsers(directorID: string): Promise<DirectorLinkedClientPortalUserModel[]>;
  unlinkClientPortalUser(directorID: string, clientPortalUserID: string): Promise<void>;
}

@injectable()
export class DirectorsService implements IDirectorsService {
  @inject(SERVICE_TYPES.CPLDirectorsClient) cplDirectorsClient!: ICPLDirectorsClient;
  @inject(SERVICE_TYPES.CPLAuthDirectorsClient) cplAuthDirectorsClient!: ICPLAuthDirectorsClient;

  async getDirectors(includeDeleted: boolean): Promise<DirectorModel[]> {
    return this.cplDirectorsClient.getDirectors(includeDeleted);
  }

  async getDirector(directorID: string, includeDeleted: boolean): Promise<DirectorModel> {
    return this.cplDirectorsClient.getDirector(directorID, includeDeleted);
  }

  async createDirector(newDirectorModel: NewDirectorModel): Promise<string> {
    return this.cplDirectorsClient.createDirector(newDirectorModel);
  }

  async updateDirector(model: UpdateDirectorModel): Promise<void> {
    return this.cplDirectorsClient.updateDirector(model);
  }

  async deleteDirector(directorID: string): Promise<void> {
    return this.cplDirectorsClient.deleteDirector(directorID);
  }

  async getLinkedClientPortalUsers(directorID: string): Promise<DirectorLinkedClientPortalUserModel[]> {
    return this.cplAuthDirectorsClient.getLinkedClientPortalUsers(directorID, false);
  }

  async unlinkClientPortalUser(directorID: string, clientPortalUserID: string): Promise<void> {
    return this.cplAuthDirectorsClient.unlinkClientPortalUser(directorID, clientPortalUserID);
  }
}
